package com.rosario.juridico.ui.screens

import com.rosario.juridico.ui.components.CajaResultadoAccionable
import androidx.compose.foundation.*
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.*
import androidx.compose.material3.*
import androidx.compose.material3.MaterialTheme.colorScheme
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import androidx.navigation.NavController
import kotlinx.coroutines.CoroutineScope

@Composable
fun ContenidoPromesa(
    navController: NavController,
    scope: CoroutineScope,
    viewModel: PromesaViewModel = PromesaViewModel.instance,
    onNavigateToAgenda: () -> Unit
) {
    val scrollState = rememberScrollState()
    val thousandSeparator = ThousandSeparatorVisualTransformation()

    LaunchedEffect(Unit) {
        viewModel.cargarDatos(scope)
    }

    Column(
        modifier = Modifier
            .fillMaxSize()
            .imePadding()
            .verticalScroll(scrollState)
            .padding(16.dp),
        verticalArrangement = Arrangement.spacedBy(16.dp)
    ) {
        Text(
            "Mediación PROMESA (Salud)",
            style = MaterialTheme.typography.titleLarge,
            fontWeight = FontWeight.Bold,
            color = colorScheme.primary
        )

        // 1. Input UHOM Base
        OutlinedTextField(
            value = viewModel.valorUhomBase,
            onValueChange = { viewModel.valorUhomBase = it.filter { c -> c.isDigit() } },
            label = { Text("Valor UHOM Base (Monto Indeterminado)") },
            modifier = Modifier.fillMaxWidth(),
            keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
            visualTransformation = thousandSeparator,
            leadingIcon = { Icon(Icons.Default.MonetizationOn, null) }
        )

        // 2. Resultado del Proceso (Dropdown)
        SeccionLabelHonorarios("Resultado del Proceso")
        var expanded by remember { mutableStateOf(false) }
        Box {
            OutlinedCard(
                onClick = { expanded = true },
                modifier = Modifier.fillMaxWidth()
            ) {
                Row(
                    modifier = Modifier.padding(16.dp).fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Text(viewModel.resultadoProceso)
                    Icon(Icons.Default.ArrowDropDown, null)
                }
            }
            DropdownMenu(
                expanded = expanded,
                onDismissRequest = { expanded = false }
            ) {
                listOf("Con Acuerdo", "Sin Acuerdo", "Desistimiento Temprano").forEach { opcion ->
                    DropdownMenuItem(
                        text = { Text(opcion) },
                        onClick = {
                            viewModel.resultadoProceso = opcion
                            expanded = false
                            // Removido el cálculo automático al cambiar la opción
                        }
                    )
                }
            }
        }

        CalculatorActionLock(
            navController = navController,
            onAction = { viewModel.calcular() }
        ) { onClick ->
            Button(
                onClick = onClick,
                modifier = Modifier.fillMaxWidth(),
                shape = RoundedCornerShape(12.dp)
            ) {
                Icon(Icons.Default.Calculate, null)
                Spacer(Modifier.width(8.dp))
                Text("Calcular Honorario PROMESA", fontWeight = FontWeight.Bold)
            }
        }
        Spacer(modifier = Modifier.height(40.dp))

        // 3. Tarjeta de Resultado
        if (viewModel.honorarioFinal > 0) {
            val textoCopia = """
                RESUMEN HONORARIOS PROMESA (SALUD)
                Resultado: ${viewModel.resultadoProceso}
                Honorario Final: $ ${viewModel.honorarioFinal.toFormato(2, true)}
                Mensaje Legal: ${viewModel.mensajeLegal}
                -------------------------------------------
                Calculado con www.juridicorosario.com
            """.trimIndent()

            CajaResultadoAccionable(
                titulo = "Honorario Final Estimado",
                textoParaCompartir = textoCopia
            ) {
                Text(
                    text = "$ ${viewModel.honorarioFinal.toFormato(2, true)}",
                    style = MaterialTheme.typography.headlineMedium,
                    color = colorScheme.primary,
                    fontWeight = FontWeight.ExtraBold
                )
                HorizontalDivider(modifier = Modifier.padding(vertical = 8.dp), color = colorScheme.onSecondaryContainer.copy(alpha = 0.2f))
                Row(verticalAlignment = Alignment.Top) {
                    Icon(Icons.Default.Info, null, modifier = Modifier.size(16.dp).padding(top = 2.dp))
                    Spacer(Modifier.width(8.dp))
                    Text(
                        text = viewModel.mensajeLegal,
                        style = MaterialTheme.typography.bodySmall
                    )
                }
            }
        }

        HorizontalDivider(Modifier.padding(vertical = 8.dp))

        // 4. Buscador (Fuzzy Search)
        Text("Consultar Normativa PROMESA", style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold)
        OutlinedTextField(
            value = viewModel.searchQuery,
            onValueChange = { viewModel.searchQuery = it },
            placeholder = { Text("Buscar por palabra clave o tag...") },
            modifier = Modifier.fillMaxWidth(),
            leadingIcon = { Icon(Icons.Default.Search, null) },
            singleLine = true
        )

        val filteredItems = viewModel.filteredNormativa

        if (viewModel.searchQuery.isNotEmpty()) {
            filteredItems.forEach { item ->
                Card(
                    modifier = Modifier.fillMaxWidth(),
                    colors = CardDefaults.cardColors(containerColor = colorScheme.surfaceVariant.copy(alpha = 0.4f)),
                    border = BorderStroke(1.dp, colorScheme.outlineVariant.copy(alpha = 0.3f))
                ) {
                    Column(Modifier.padding(12.dp)) {
                        Text(item.titulo, fontWeight = FontWeight.Bold, color = colorScheme.primary)
                        Text(item.texto, style = MaterialTheme.typography.bodySmall)
                    }
                }
            }
            
            if (filteredItems.isEmpty()) {
                Text(
                    "No se encontraron resultados para '${viewModel.searchQuery}'",
                    style = MaterialTheme.typography.bodySmall,
                    color = Color.Gray,
                    modifier = Modifier.padding(8.dp)
                )
            }
        }

        Spacer(Modifier.height(16.dp))

        Button(
            onClick = onNavigateToAgenda,
            modifier = Modifier.fillMaxWidth(),
            colors = ButtonDefaults.buttonColors(containerColor = colorScheme.secondary),
            shape = RoundedCornerShape(12.dp)
        ) {
            Icon(Icons.Default.DateRange, contentDescription = null)
            Spacer(Modifier.width(8.dp))
            Text("Ir a Agenda PROMESA")
        }
        
        Spacer(Modifier.height(24.dp))
    }
}
